/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Classification_NewInputs */

const vi_product_classification_new = /** @type {(inputs: Product_Classification_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm phân loại`)
};

/**

* @param {Product_Classification_NewInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_classification_new = /** @type {((inputs?: Product_Classification_NewInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Classification_NewInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_classification_new(inputs)
});